import { MenuItem } from '@mui/material';
import styled from 'styled-components';

export const AutoCompleteFieldStyled = styled.div`
  .MuiOutlinedInput-notchedOutline {
    border-color: #080425;
  }
  .MuiSelect-select {
    text-overflow: ellipsis;
    width: 100%;
    padding: 2px 15px 10px;
    font-size: 13px;
    line-height: 30px;
    border: 1px solid #080425;
    color: #2b3952;
    z-index: 1;
    height: 22px;
  }

  .MuiAutocomplete-root {
    &:hover {
      border-color: transparent;
    }
    &:focus {
      border-color: transparent;
    }
    .MuiInputBase-root {
      row-gap: 0px;
      border: 1px solid #080425;
      overflow: auto;
      padding: 0px 0px 0px 5px;
      height: auto;
      width: 100%;

      &.Mui-disabled {
        border-color: #b9bec7;
        cursor: not-allowed;
        pointer-events: none;
        .MuiAutocomplete-input {
          color: rgba(0, 0, 0, 0.38);
          -webkit-text-fill-color: rgba(0, 0, 0, 0.38);
        }
      }
      fieldset {
        border: none;
        &:hover {
          border: none;
        }
        &:focus {
          border: none;
        }
      }
    }
  }

  .MuiAutocomplete-inputRoot .MuiAutocomplete-input {
    /* padding: 8px 4px 8px 6px !important; */
  }
  .MuiSvgIcon-root {
    display: ${(props) => (props.freeSolo ? 'none' : 'block')};
  }
  .label {
    color: #301d35;
    font-size: 13px;
    margin-bottom: 4px;
    font-weight: bold;
  }
`;

export const MenuItemStyled = styled(MenuItem)`
  &.menu-item {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding-left: 6px !important;
  }
`;
